module.exports = __webpack_public_path__ + "static/media/Nidalee.335f7864.png";